// theming/ThemeCardGrid.jsx
import React, { useMemo } from 'react';
import Button from '@dashboard/components/Button';
import { ThemeCard } from './ThemeCard';
import { orderThemesForCards } from './orderThemesForCards';

const VISIBLE_COUNT = 6;

export function ThemeCardGrid({
  themes,
  currentThemeId,
  defaultThemeId,
  colorMode,
  onSelect,
  onViewAll,
  onSetDefault,
  onDuplicate,
  onDelete,
  hideActions = false,
}) {
  const ordered = useMemo(
    () => orderThemesForCards(themes, { defaultThemeId }),
    [themes, defaultThemeId],
  );

  const visible = useMemo(() => {
    const top = ordered.slice(0, VISIBLE_COUNT);
    if (!currentThemeId) return top;
    if (top.some(theme => theme._id === currentThemeId)) return top;
    const selected = ordered.find(theme => theme._id === currentThemeId);
    if (!selected) return top;
    return [top[0], selected, ...top.slice(1, VISIBLE_COUNT - 1)];
  }, [ordered, currentThemeId]);

  const moreCount = Math.max(0, ordered.length - VISIBLE_COUNT);

  return (
    <div>
      <div className="grid grid-cols-3 gap-2">
        {visible.map(theme => (
          <ThemeCard
            key={theme._id}
            theme={theme}
            active={theme._id === currentThemeId}
            isDefault={theme._id === defaultThemeId}
            canDelete={theme.scope === 'seller'}
            colorMode={colorMode}
            onSelect={onSelect}
            onSetDefault={onSetDefault}
            onDuplicate={onDuplicate}
            onDelete={onDelete}
            hideActions={hideActions}
          />
        ))}
      </div>

      {moreCount > 0 && (
        <Button
          appearance="secondary"
          size="full"
          onClick={onViewAll}
          className="mt-2.5"
        >
          View all themes ({ordered.length})
        </Button>
      )}
    </div>
  );
}

export default ThemeCardGrid;
